import { PropsWithChildren } from 'react';
import CSVExportButton, { CSVOptions } from './CSVExportButton';
import { actions, container, subtitleStyles, titleStyles } from './ChartHeader.css';
import { RowData } from '@tanstack/react-table';

export type ChartHeaderProps<T extends RowData> = {
  title?: string;
  subtitle?: string;
  csvOptions?: CSVOptions<T>;
} & PropsWithChildren;

export function ChartHeader<T extends RowData>({
  title,
  subtitle,
  csvOptions,
  children,
}: ChartHeaderProps<T>) {
  return (
    <div className={container}>
      <div>
        <div className={titleStyles}>{title}</div>
        <div className={subtitleStyles}>{subtitle}</div>
      </div>
      {csvOptions?.data && (
        <div className={actions}>{<CSVExportButton csvOptions={csvOptions} />}</div>
      )}
      {children && <div className={actions}>{children}</div>}
    </div>
  );
}

export default ChartHeader;
